<template>
    <div>
        <el-row>
            <el-col :span="2" style="font-size:28px; text-align: center; padding-top: 19px">
                <el-tooltip class="item" effect="dark" content="返回上一级页面" placement="bottom-start" :disabled="showTooltip">
                    <i class="el-icon-arrow-left" @click="onBack" style="cursor: pointer"></i>
                </el-tooltip>
            </el-col>
            <el-col :span="12">
                <h3><span v-show="!create">修改项目</span><span v-show="create">新增项目</span></h3>
            </el-col>
        </el-row>
        <div style="margin: 8px 40px 40px; border-bottom: 1px solid #CCC"></div>
        <div style="max-width: 800px">
            <el-form ref="form" :model="form" :rules="formRules" label-width="180px" v-loading="showLoading">
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="项目编码" required prop="itemCode">
                            <el-input v-model="form.itemCode" placeholder="请输入项目编码" maxlength="30"
                                show-word-limit :disabled="!create"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                     <el-col :span="24">
                        <el-form-item label="项目名称" required prop="itemName">
                            <el-input v-model="form.itemName" placeholder="请输入项目名称" maxlength="100"
                                show-word-limit></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-form-item>
                    <el-button type="primary" size="small" @click="onSave" v-loading="showBtnLoading">确定</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
    import _ from "lodash"

    let _kits, _form
    export default {
        props: ["entity", "mode"],
        data() {
            let create = !this.entity.itemCode
            let form = {
                agencyCode: this.entity.agencyCode,
                isValid: "Y",
                itemCode: this.entity.itemCode,
                itemName: this.entity.itemName
            }
            let data = {
                fileList: [],
                showLoading: true,
                showTooltip: false,
                showBtnLoading: false,
                einvtypeCodeOptions: [],
                create,
                form,
                formRules: {
                    itemCode: [
                        { required: true, message: "请输入项目编码", trigger: "blur" }
                    ],
                    itemName: [
                        { required: true, message: "请输入项目名称",  trigger: "blur" }
                    ]
                },
                einvoiceTypeOptions: [],
                supervisorSealOptions: []
            }
            console.log("data is ", data)
            return data
        },
        methods: {
            onBack() {
                this.$emit("back")
            },
            onSave() {
                _form.submit();
            }
        },
        created() {
            _kits = this.$kits()
        },
        mounted() {
            _form = _kits.control.getStandardForm({
                name: "form",
                api: this.create ? "SAVEAGENCYITEM" : "UPDATEAGENCYITEM"
            })
            //*
            setTimeout(() => {
                _kits.page.foucus("ipt01")
                this.showLoading = false
                this.showTooltip = true
            }, 300)
        }
    }
</script>
